import jwtDecode from 'jwt-decode';

import { AuthUtils } from '@dndbeyond/authentication-lib-js';

import config from '../config';

const getShortTermToken = AuthUtils.makeGetShortTermToken({
    authUrl: config.authEndpoint,
    throwOnHttpStatusError: false,
});

const getDecodedShortTermToken = () => getShortTermToken().then((jwt) => (jwt ? jwtDecode(jwt) : null));

const getAuthHeaders = AuthUtils.makeGetAuthorizationHeaders({
    madeGetShortTermToken: getShortTermToken,
});

const del = (url, data) =>
    getAuthHeaders().then((authHeaders) =>
        fetch(url, {
            method: 'DELETE',
            headers: {
                ...authHeaders,
                Accept: 'application/json',
                'Content-Type': data ? 'application/json' : undefined,
            },
            body: data ? JSON.stringify(data) : undefined,
        }),
    );

const get = (url) =>
    getAuthHeaders().then((authHeaders) =>
        fetch(url, {
            method: 'GET',
            headers: {
                ...authHeaders,
                Accept: 'application/json',
            },
        }),
    );

const getWithCookies = (url) =>
    fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    });

const post = (url, data) =>
    getAuthHeaders().then((authHeaders) =>
        fetch(url, {
            method: 'POST',
            headers: {
                ...authHeaders,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        }),
    );

const put = (url, data) =>
    getAuthHeaders().then((authHeaders) =>
        fetch(url, {
            method: 'PUT',
            headers: {
                ...authHeaders,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        }),
    );

const getJsonFromResponse = (response) => response.json();

const getDataFromJson = (json) => (json ? json.data : null);

const getPaginationFromJson = (json) => (json ? json.pagination : null);

const getConfigFromJson = (json) => (json ? json.config : null);

const getErrorCodeFromJson = (json) => (json ? json.type : null);

const getDataFromResponse = (response) => getJsonFromResponse(response).then(getDataFromJson);

const delJson = (url) => del(url).then(getDataFromResponse);

const getJson = (url) => get(url).then(getDataFromResponse);

const postJson = (url, data) => post(url, data).then(getDataFromResponse);

const putJson = (url, data) => put(url, data).then(getDataFromResponse);

const keyValuePairsToQueryString = (keyValuePairs) =>
    keyValuePairs
        .map(({ key, value }) => (Array.isArray(value) ? value.map((v) => `${key}=${v}`).join('&') : `${key}=${value}`))
        .join('&');

export default {
    del,
    get,
    getWithCookies,
    post,
    put,
    delJson,
    getJson,
    postJson,
    putJson,
    getDataFromJson,
    getDataFromResponse,
    getJsonFromResponse,
    getPaginationFromJson,
    getConfigFromJson,
    getErrorCodeFromJson,
    getDecodedShortTermToken,
    keyValuePairsToQueryString,
};
